import React, { Component, Fragment } from 'react'
import { Emoji } from 'emoji-mart'
import PropTypes from 'prop-types'
import { Input, Button } from '@drifthq/tide-core'
import { OnboardingHeader } from 'components/OnboardingHeader'
import { DisabledButton } from 'components/OnboardingDisabledButton'
import { map, values, pathOr, contains } from 'ramda'
import { variation } from 'modules/experiment/helpers'
import { track } from 'utils/trackingUtils'

import ProgressMeterWithLogo from 'components/ProgressMeterWithLogo'

import './style.css'

const DISABLED_TOOLTIP = <div>Please choose at least one<br/>option from the list above</div>

const INTENT_OPTIONS_ORDERS = {
  "order_0": [0, 1, 2],
  "order_1": [1, 0, 2],
  "order_2": [2, 0, 1]
}

const INTENT_OPTIONS = {
  0: {
    title: "Allow site visitors to chat live with sales reps",
    emoji: "speech_balloon",
    key: "chat-with-sales"
  },
  1: {
    title: "Qualify leads using chatbots",
    emoji: "robot_face",
    key: "qualify-leads"
  },
  2: {
    title: "Book meetings for sales reps using chatbots",
    emoji: "calendar",
    key: "book-meetings"
  }
}

const Option = ({ emoji, checked, onChange, title }) => (
  <div className="setup-intent-option" onClick={onChange}>
    <Emoji emoji={emoji} size={24} />
    <span className="setup-intent-option-title">{title}</span>
    <Input type="checkbox" checked={checked} />
  </div>
)

class Intent extends Component {
  static propTypes = {
    onContinue: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props)
    const variationIntentOrder = variation('onboarding_intent_order') || "order_0"

    this.state = {
      intentsOptions: map(orderIndex => INTENT_OPTIONS[orderIndex], INTENT_OPTIONS_ORDERS[variationIntentOrder]),
      intentOrder: variationIntentOrder
    }
  }

  makeOnChange = (option, index) => {
    let intentsOptions = [...this.state.intentsOptions]
    let optionCopy = { ...option }
    let checked = pathOr(false, ['checked'], optionCopy)
    optionCopy.checked = !checked
    optionCopy.rank = index + 1
    intentsOptions[index] = optionCopy
    this.setState({ intentsOptions })
  }

  renderIntentOption = (option, index) => {
    return (
      <Option
        {...option}
        onChange={() => this.makeOnChange(option, index)}
      />
    )
  }

  isSubmitEnabled = () => {
    const { intentsOptions } = this.state
    return contains(true, values(intentsOptions).map(value => value.checked))
  }

  trackSelectedIntent = () => {
    const { intentsOptions, intentOrder } = this.state
    const { name } = this.props
    const selectedOptions = intentsOptions.filter(val => val.checked === true)
    const intentRanks = selectedOptions.map(val=> val.rank)
    const intentKeys = selectedOptions.map(val=> val.key)
    track(`${name} Intent- Submitted`, { order: intentOrder, intentKeys, intentRanks })
  }

  onClick = () => {
    const { onContinue } = this.props
    this.trackSelectedIntent()
    onContinue()
  }

  render() {
    const { intentsOptions } = this.state
    const { index, stepCount } = this.props

    return (
      <Fragment>
        <ProgressMeterWithLogo currentLength={index} maxLength={stepCount - 1}/>
        <div className="setup-intent-wrapper">
          <OnboardingHeader
            title="What will you use Drift for?"
            description="We want to make sure your personalized onboarding strategy aligns with your goals. Please choose at least one option from the list below."
          />
          <div className="setup-intent--container">
            <Fragment>{intentsOptions.map(this.renderIntentOption)}</Fragment>
            { !this.isSubmitEnabled() && <DisabledButton buttonClassName="setup-intent-button" toolTipText={DISABLED_TOOLTIP}/> }
            { this.isSubmitEnabled() &&
              <Button className="setup-intent-button"
                submit
                onClick={this.onClick}>
                Next
              </Button>
            }
          </div>

        </div>
      </Fragment>

    )
  }
}

export default Intent


// WEBPACK FOOTER //
// ./src/layouts/OnboardingIntentStep/index.js